<div style="font-size: 16px !important">
    <div nz-row class="pl-4 pr-4 mt-2">
        @if(!isTimeOff) {
        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-1 pb-2">
                    Consumer Name:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{lineItem.consumerName}}</div>
            </div>
        </div>

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-1 pb-2">
                    Consumer PPL ID:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{lineItem.consumerPplId}}</div>
            </div>
        </div>
        }

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-1 pb-2">
                    PA Name:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{rowData.providerName}}</div>
            </div>
        </div>

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-1 pb-2">
                    PA PPL ID
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{rowData.providerPplId}}</div>
            </div>
        </div>
    </div>

    @if(mode == 'view' && !isTimeOff) {
    <div class="custom-row pr-3">
        <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
            (click)="onEdit()"></ppl-button>
    </div>
    }
    @if(mode == 'view') {
    @if(timeoffData && timeoffData.length > 0) {
    <div class="p-3">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false" [enableActions]="false"
            [data]="timeoffData" (rowDetailEventTs)="rowClickedTs($event)" (rowDetailEvent)="rowClicked($event)"
            (selectionChanged)="selectionChanged($event)" [disableSelection]="false" [cols]="timeoff_cols"
            [gridTitle]="false" [pagination]="true" [loadPage]="false" [showExpandIcon]="false"
            [actionButtons]="actionButtons" [showLineItem]="false" [timesheetFor]="timesheetFor">
        </ppl-list-table>
    </div>

    @if(!isProviderView) {
    <div class="custom-row" style="width: 100%;">
        <ppl-button (click)="onProcessClick()" style="margin-right: 8px;" label="Submit for Processing"
            icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
    }
    }}
    @else {
    <ppl-timesheets-add-entries [entryType]="timeEntry" [payPeriod]="filetredPayPeriod" [consumers]="consumers"
        [action]="action" [timesheetData]="timesheetData" [staffView]="true"
        (timesheetAdded)="timesheetAdded($event)" (onClose)="onCancel()"></ppl-timesheets-add-entries>
    }
</div>

<div class="filter-panel">
    <ng-template #pendedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData"
            (onSaveComplete)="onSaveAdjustment($event)"></ppl-timesheet-staff-errorcode>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #deniedDialog let-cancel="cancel">
        <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData"></ppl-timesheet-staff-deniedreasons>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDataDialog let-cancel="cancel">
        <ppl-timesheet-staff-authdata [authData]="authData"
            (showAuthDetails)="showAuthDetails($event)"></ppl-timesheet-staff-authdata>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [pageSource]="'timesheet'"></ppl-authorization-details>
    </ng-template>
</div>